<style lang="scss">
  .card{
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
  }
  .vtable{
    min-height: 75vh !important;

  }
  .bt-float-rigth{
    float: right;
    margin-top: 20px;
  }
  .v-table-body div:nth-child(9){display:none;}
  .v-table div:nth-child(9){display:none;}
</style>
<template lang="pug">
  .row
    .table-vue(  style="width: 1100px" )
      a.bt-float-rigth.waves-effect.waves-light.btn.blue-grey.lighten-1.white-color
        i.material-icons.right save
        vue-json-to-csv(:json-data="excelData" :csv-title="'SOLICITUDES_CSV'") Descargar
      
      vue-table-dynamic( :params="params" @select="onSelect" @selection-change="onSelectionChange" ref="table")
      modal-desktop( :ModalData="getSendData()") 
</template>
<script>
import VueTableDynamic from 'vue-table-dynamic'
import {func} from '../func.js'
import ModalDesktop from './ModalDesktop'
import M from 'materialize-css'
import firebase from '../config'
import VueJsonToCsv from 'vue-json-to-csv'
const { db } = firebase;
let dt = require('dateformat');
dt.i18n = {
    dayNames: [
        "Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", 
        "Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado" 
    ],
    monthNames: [
      "Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic",
      "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ],
    timeNames: [
        'a', 'p', 'am', 'pm', 'A', 'P', 'AM', 'PM'
    ]
  };
export default {
  name: "DesktopBackOffice",
  components: {
    VueTableDynamic,
    ModalDesktop,
    VueJsonToCsv
  },
  data() {
    return {
      tbHaders:[["UsrSol", "OT", "Cliente", "Estatus", "Created", "Descripcion", "Fecha", "# Solicitud", "ID Solicitud"],],
      excelData:[],
      solicitudesDisponibles:[],
      dataChecked:[],
      dataInArray:[],
      params: {
        data: [],
        header: 'row',
        border: true,
        stripe: true,
        enableSearch: true,
        sort: [0, 1,2,3],
        pagination: true,
        pageSize: 20,
        height: 180,
        showCheck: true,
        minWidth:1100,
        height:500
      }
    }
  },
  firestore: {
    // solicitudesDisponibles: db.collection('todos'),
  },
  methods: {
    getDateFormat($d,$f) {
      if($d == null )
        return;
      let now = new Date($d);
      let f = ($f == "D") ? dt(now, "yyyy, mmmm d"): dt(now, "h:MM TT") ;
      return f;
    },
    openModal(){
      let elems = document.querySelector("#modal1");
      let modal = M.Modal.init(elems, {});
      modal.open();
    },
    getSendData() {
      // this.dataChecked.ID = i.substring(0,5)
      return this.dataChecked;
    },
    onSelect (isChecked, index, data) {
      // console.log('onSelect: ', isChecked, index, data)
      let _x = this.$refs.table.getCheckedRowDatas(true);
      // console.log("Data: ", _x[1])

      for( let k in this.dataInArray){
        if(  undefined != this.dataInArray[k][_x[1][7]] ){
          console.log("All info: ",this.dataInArray[k]);
          this.dataChecked = this.dataInArray[k][_x[1][7]];
          this.dataChecked.ID = _x[1][7].substring(0,5);
          this.dataChecked.idNum = _x[1][8];
          this.openModal()
        }
      }

      setTimeout(() => {
        // setAllRowChecked:function
        this.$refs.table.setAllRowChecked(false);
      }, 10 );

      
    },
    onSelectionChange (checkedDatas, checkedIndexs, checkedNum) {
      // console.log('onSelectionChange: ', checkedDatas, checkedIndexs, checkedNum)
    },
    gatData() {
      this.params = {
 
        // pageSizes: [5, 10, 20, 50]
      }
    },
    printElements(){
      let __ = this;
      let _tmp = [];
      // __.dataInArray.forEach( element => console.log(typeof(element.)))
      for( let j in __.dataInArray){
        Object.keys(__.dataInArray[j]).forEach(key => {
          // console.log(key, __.dataInArray[j][key]);
          let _x = {
            "ShortID"               : key,
            "FullID"                : __.dataInArray[j][key].id,

            "OT"                    : (__.dataInArray[j][key].OT == null )? "No asignado" : __.dataInArray[j][key].OT,
            "UsuarioQueGenero"      : __.dataInArray[j][key].genero,
            "FechaDeServicio"       : func.getDateFormat(__.dataInArray[j][key].fecha, "D"),
            "HoraDeServicio"        : func.getDateFormat(__.dataInArray[j][key].hora, "H"),
            "Finalizada"            : (__.dataInArray[j][key].finishHim) ? "Si" : "No",
            "DateCreated"           : __.dataInArray[j][key].created,
            "Cliente"               : __.dataInArray[j][key].cliente,
            
            "costoHora"             : __.dataInArray[j][key].costoHora,
            "costoTraslado"         : __.dataInArray[j][key].costoTraslado,
            "costoHoraExtra"        : __.dataInArray[j][key].costoHoraExtra,
            "UsuarioQue Solicita"   : __.dataInArray[j][key].UsrSol,
            "gruaTipo"              : __.dataInArray[j][key].gruaTipo,
            "Operador"              : __.dataInArray[j][key].Operador,
            "Ayudante"              : __.dataInArray[j][key].Ayudante,
            "AreaManiobra"          : __.dataInArray[j][key].AreaManiobra,
            "departamento"          : __.dataInArray[j][key].departamento,
            "Peso"                  : __.dataInArray[j][key].peso,
            "Altura"                : __.dataInArray[j][key].altura,
            "Radio"                 : __.dataInArray[j][key].radio,
            "Descripcion"           : __.dataInArray[j][key].descripcion,
            "Responsable"           : __.dataInArray[j][key].responsable,
            "responsableSitio"      : __.dataInArray[j][key].responsableSitio,
            "contacto"              : __.dataInArray[j][key].contacto,
            "createdBy"             : __.dataInArray[j][key].createdBy,
            "ComentarioCliente"     :(__.dataInArray[j][key].comentarioCliente == undefined) ? " No realizado": __.dataInArray[j][key].comentarioCliente
          };
          _tmp.push(_x);
        });
        // console.log("Arr: => ", __.dataInArray[j].length);

        /*
          ID: "U0S3l"
          id: "U0S3lAgFw7OybNqaf04q"
          OT: "# 2121313"
          genero: "Elias Martinez(Operaciones)"
          fecha: "2020-03-20T12:53:23.193Z"

          hora: "2020-03-20T12:53:23.193Z"
          finishHim: true
          created: "2020-03-20T12:54:11.354Z"
          cliente: "GrafTech"
          
          costoHora: "12000"
          costoTraslado: "12"
          costoHoraExtra: "121"
          UsrSol: "Caleb Lopez(Cliente)"
          gruaTipo: "Grua indus-80 N4946"
          Operador: "Gonzalez Tellez Baldomero"
          Ayudante: "Gonzalez Tellez Baldomero"
          AreaManiobra: "Empaque A"
          departamento: "Proyectos"
          peso: "1000"
          altura: "22"
          radio: "23"
          descripcion: "DECRIPCION DE LA MANIOBRA QUE SE REALIZARA . . .. "
          responsable: "JUAN CAMANEY"
          responsableSitio: "JOSE JOSE"
          contacto: "JOSE BARAJAS"
          createdBy: "I7L4YFiSr6Tgcssu2qZO2j5Q5dM2"
          comentarioCliente: "bien echo↵"
        */

      }
      this.excelData = _tmp;
    },
    getStatus($str){
      let leyend = "";
      switch ($str) {
        case 0:
          leyend = "Creada.";
          break;
        case 1:
          leyend = "En Revisión OP.";
          break;
        case 2:
          leyend = "En revisión por OP.";
          break;
        case 3:
          leyend = "En revisión por ADMS."
          break;
        case 4:
          leyend = "OT asignada."
          break;
        case 5:
          leyend = "Finalizada."
          break;
      
        default:
          leyend = "No asignada."
          break;
      }
      return leyend;
    },
  },
		created () {
      let _self = this;
      let solicitudes = [];
      let sol2 = [];
      db.collection('todos')
      // .where('finishHim', '==', true)
			.onSnapshot(function(snapshot) {
        solicitudes = [];
        _self.params.data = [["UsrSol", "OT", "Cliente", "Estatus", "Created", "Descripcion", "Fecha", "# Solicitud", "ID Solicitud"]];
				sol2 = [];
				snapshot.forEach(function(doc) {
          let _tp =[];
          let _tpm = doc.data();
          
          _tpm.id  = doc.id;
            
          solicitudes.push(_tpm);

          _tp[""+doc.id+""] = _tpm;
          sol2.push(_tp);
            // _self.re.id  = doc.id;
          });
          _self.solicitudesDisponibles =  solicitudes ;
          
          console.log("PARAMS DATA: =>",_self.params.data);
          solicitudes.forEach(ele => {
            let _tempArr = [ ele.UsrSol,ele.OT, ele.cliente, _self.getStatus(ele.status[1]), ele.created, ele.descripcion , `${func.getDateFormat(ele.fecha,"H")} - ${func.getDateFormat(ele.fecha,"D")}`, ele.id, func.returnID(ele.id) ]
            // console.log(_tempArr);
            _self.params.data.push(_tempArr);
            // for(let i; i < element.length;i++)
          });
        _self.dataInArray = sol2;
        _self.printElements();
      // console.log("dataInArray: ", sol2);
      }, function(error) { console.log(error); });	
			
		}
}
</script>